var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isVisible
    ? _c(
        "div",
        {
          staticClass: "form-item radio",
          class: [_vm.item.data.htmloptions, { "is-invalid": _vm.isInvalid }],
        },
        [
          _vm.item.data.question != ""
            ? _c("Label", {
                attrs: { item: _vm.item, "is-invalid": _vm.isInvalid },
              })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "radio-container", class: _vm.displayType },
            _vm._l(_vm.answeroptions, function (answer, index) {
              return _c("div", { key: answer.id, staticClass: "radio-item" }, [
                _c("input", {
                  attrs: {
                    type: "radio",
                    id: answer.id,
                    name: `${_vm.item.data.id}`,
                  },
                  domProps: {
                    value: answer.value,
                    checked: _vm.isChecked(answer),
                  },
                  on: {
                    change: function ($event) {
                      return _vm.updateFormValue(
                        _vm.item.data.uniqlabel,
                        $event.target.value
                      )
                    },
                  },
                }),
                _vm._v(" "),
                _c("label", { attrs: { for: answer.id } }, [
                  _vm._v(" " + _vm._s(answer.label) + " "),
                ]),
              ])
            }),
            0
          ),
          _vm._v(" "),
          _vm.errorMessage
            ? _c("error-message", [_vm._v(_vm._s(_vm.errorMessage))])
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }